import { AuthenticationOptions, IUserProfile } from '@xero/identity-types';
import XUILoader from '@xero/xui/react/loader';
import { parse } from 'query-string';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import App from './App';
import { isDev } from './helpers/env';
import { userMock } from './mocks/mockData';
import { IInstallation } from './models';
import { setOAuthCode } from './redux/slices/ConnectionSlice';
import { updateInstallation } from './redux/slices/InstallationSlice';
import { setTenantId } from './redux/slices/OrganisationSlice';
import { updateUser, userSelectors } from './redux/slices/UserSlice';
import { useAppDispatch } from './redux/store';

export const AuthHandler: FC = () => {
    const dispatch = useAppDispatch();

    const user = useSelector(userSelectors.user);

    useEffect(() => {
        (async () => {
            const installationDataEl = document.getElementById('integration-data');
            const installation: IInstallation = { ...JSON.parse(installationDataEl!.textContent!) };

            const identityDataEl = document.getElementById('identity');
            const authenticationOptions: AuthenticationOptions = { ...JSON.parse(identityDataEl!.textContent!) };
            const authority = authenticationOptions.authority!;

            // TODO remove organisationId once we can control what billing returns
            const queryParameters = parse(window.location.search);
            const organisationId = queryParameters.organisationId ?? queryParameters.tenantId;
            const tenantId = organisationId instanceof Array ? organisationId[0] : organisationId;
            const origin = queryParameters.origin instanceof Array ? queryParameters.origin[0] : queryParameters.origin;

            if (isDev()) {
                dispatch(
                    updateUser({
                        ...userMock,
                        tenantId,
                        origin,
                    })
                );
            } else {
                const authenticationService = new window.XeroIdentity.AuthenticationService(authenticationOptions);
                const secureFetch = new window.XeroIdentity.SecureFetch(authenticationService);
                window.XERO = window.XERO || {};
                window.XERO.secureFetch = secureFetch;
                await authenticationService.getUserProfileWithAutomaticSignIn().then((userProfile: IUserProfile) => {
                    if (userProfile) {
                        const userState = { ...userProfile, tenantId, origin };
                        dispatch(updateUser(userState));
                    }
                });
            }

            dispatch(updateInstallation(installation));
            if (tenantId) {
                dispatch(setTenantId(tenantId!));
            }

            // if the referrer is identity, ignore the code
            const code = document.referrer.startsWith(authority) ? undefined : parse(window.location.search).code;
            const oAuthCode = code instanceof Array ? code[0] : code;
            if (oAuthCode) {
                dispatch(setOAuthCode(oAuthCode));
            }
        })();
    }, [dispatch]);

    const renderApp = () => {
        if (!user.xero_userid) {
            return <XUILoader ariaLabel='Loading' />;
        }

        return <App />;
    };

    return renderApp();
};

export default AuthHandler;
